import {Component, OnInit} from '@angular/core';
import {QuotesService} from '../../../../../../../../../quotes/src/app/data/quotes.service';
import {InstallationQuote} from '../../../../../../../../../quotes/src/app/data/Installation-quote';
import {MiscSnackBarService} from '../../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {
  InstallationQuoteDialogComponent
} from './installer-quote/installation-quote-dialog/installation-quote-dialog.component';
import {MatDialog} from '@angular/material/dialog';


class InstallationQuoteGroup {
  quotes: InstallationQuote[];
  title: string;
}

@Component({
  selector: 'app-installer-quotes',
  templateUrl: './installer-quotes.component.html',
  styleUrls: ['./installer-quotes.component.scss']
})
export class InstallerQuotesComponent implements OnInit {
  quoteGroups: InstallationQuoteGroup[] = [];
  quoteMap = new Map<string, InstallationQuote[]>();

  sortMap = new Map();

  loadingSpinner = true;

  constructor(
    protected matDialog: MatDialog,
    protected quoteService: QuotesService,
    protected miscSnackBarService: MiscSnackBarService
  ) {
    this.sortMap.set('Quote Pending', 0)
    this.sortMap.set('Awaiting Approval', 1)
    this.sortMap.set('Awarded', 2)
    this.sortMap.set('Completed', 3)
    this.sortMap.set('Closed - Not Awarded', 4)
  }

  ngOnInit(): void {
    this.getQuotes()
  }

  sortByGroup(quotes: InstallationQuote[]) {
    this.quoteGroups = []
    this.quoteMap.clear()

    quotes.forEach(quote => {
      if (!this.quoteMap.has(quote.statusTitle)) {
        this.quoteMap.set(quote.statusTitle, [])
      }

      this.quoteMap.get(quote.statusTitle).push(quote)
    })

    this.quoteMap.forEach((val, key) => {
      this.quoteGroups.push({
        title: key,
        quotes: val
      })
    })

    this.quoteGroups.sort((a, b) => {
      const aOrder = this.sortMap.has(a.title) ? this.sortMap.get(a.title) : 0
      const bOrder = this.sortMap.has(b.title) ? this.sortMap.get(b.title) : 0

      return aOrder - bOrder
    })
  }

  getQuotes() {
    this.quoteService.getMyQuotes().subscribe(quotes => {
      this.sortByGroup(quotes.content)

      this.loadingSpinner = false;
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.loadingSpinner = false;
    })
  }

  openQuote(quote: InstallationQuote) {
    const dialogRef = this.matDialog.open(InstallationQuoteDialogComponent, {
      data: quote,
      panelClass: 'quote-body-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getQuotes()
    });
  }

}
